import type { Path, To } from 'react-router';

const AI_PREFIX = [
  'when',
  'what',
  'where',
  'who',
  'whom',
  'whose',
  'why',
  'which',
  'how',
];

// this logic is duplicated in the backend in lib/slab/ai/ask.ex,
// so any changes made here should also be made there.
export const isAiQuestion = (query: string) => {
  const lowercaseWords = query
    .toLowerCase()
    .trim()
    .split(/['`\s]+/);
  const restWords = lowercaseWords.slice(2);
  return (
    lowercaseWords.length >= 3 &&
    (AI_PREFIX.includes(lowercaseWords[0] ?? '') ||
      restWords.some((word) => word.endsWith('?')))
  );
};

export const getAiAskLocation = (location?: Partial<Path>): To | undefined => {
  const search = new URLSearchParams(location?.search);
  search.set('mode', 'ask');

  return location
    ? {
        ...location,
        search: `?${search}`,
      }
    : location;
};
